import {useGetData} from '../../src/apiservice/apiCall'


export function useVideos(take){
	var takeQuery ='';
	if(take)
		takeQuery ='?take='+take;
	return useGetData('/api/WebApi/GetVideos'+takeQuery)
}
